import { render } from "./PatientSchedulingsListView.vue?vue&type=template&id=0cd19bfa"
import script from "./PatientSchedulingsListView.vue?vue&type=script&lang=js"
export * from "./PatientSchedulingsListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__